import _ from 'lodash';
import urls from '../../../util/urls';
import groupActionTypes from './actionTypes';
import queryString from 'query-string';
import { selectActiveAccountId } from '../account/selectors';
import NotificationHelper from '../../util/NotificationHelper';

function getResponseContextProps(contextKey: string) {
  if (!contextKey) return null;

  return {
    contextKey,
    parseResponseItems: (data: any) => _.get(data, 'items', []),
    parseNextToken: (data: any) => _.get(data, 'links.next'),
  };
}

function fetchUserGroups({ contextKey }: { contextKey?: string } = {}) {
  return async (dispatch: any, getState: any) => {
    const store = getState();
    const account = _.get(store, 'account.activeAccount', '');
    const params = account ? { account, pageSize: 100 } : { pageSize: 100 };
    await dispatch({
      type: groupActionTypes.FETCH_USER_GROUPS,
      url: urls.api.accounts.groups({ params }),
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      responseContext: getResponseContextProps(contextKey),
    });
  };
}

function fetchAccountGroups({
  params,
  next,
  contextKey,
}: { params?: any; next?: any; contextKey?: string } = {}) {
  return async (dispatch: any) => {
    let nextUrl;
    if (next) {
      const parts = next.split('?');
      const nextParams = { ...queryString.parse(parts.pop()), ...params };
      nextUrl = urls.api.accounts.groups({ params: nextParams });
    }

    await dispatch({
      type: groupActionTypes.FETCH_ACCOUNT_GROUPS,
      url: nextUrl || urls.api.accounts.groups({ params }),
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      responseContext: getResponseContextProps(contextKey),
    });
  };
}

function createGroup(
  name: string,
  description: string,
  notification = new NotificationHelper(),
) {
  return async (dispatch: any, getState: any) => {
    const activeAccountId = selectActiveAccountId(getState());
    await dispatch({
      type: groupActionTypes.CREATE_GROUP,
      url: urls.api.accounts.groups(),
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({
          account: activeAccountId,
          description,
          name,
          type: 'closed',
        }),
      },
      ...notification.getAsyncRequestHandlers(),
    });
  };
}

function updateGroup(group: any, notification = new NotificationHelper()) {
  // remove deleteProtected from update as this is only setable from the private API
  const withoutPrivateProps = _.omit(group, ['deleteProtected']);
  return async (dispatch: any) => {
    await dispatch({
      type: groupActionTypes.UPDATE_GROUP,
      url: urls.api.accounts.groups({ id: group.id }),
      fetchOptions: {
        method: 'PUT',
        body: JSON.stringify(withoutPrivateProps),
      },
      ...notification.getAsyncRequestHandlers(),
    });
  };
}

function deleteGroup(group: any, notification = new NotificationHelper()) {
  return async (dispatch: any) => {
    await dispatch({
      type: groupActionTypes.DELETE_GROUP,
      url: urls.api.accounts.groups({ id: group.id }),
      fetchOptions: {
        method: 'DELETE',
      },
      ...notification.getAsyncRequestHandlers(),
    });
  };
}

export default {
  fetchUserGroups,
  fetchAccountGroups,
  createGroup,
  updateGroup,
  deleteGroup,
};
